import React from 'react';
import PropTypes from 'prop-types';
import {Chart} from 'react-google-charts';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {withRouter} from 'react-router';
import GreenLeafApi from '../utils/GreenLeafApi';

export class CompanyTreeMapByProgram extends React.Component {

  constructor(props) {
    super(props);

    this.chartEvents = [
      {
        eventName: 'select',
        callback: (chartWrapper) => {
          let selected = chartWrapper.getDataTable().getValue(chartWrapper.getChart().getSelection()[0].row, 0);
          let parent = chartWrapper.getDataTable().getValue(chartWrapper.getChart().getSelection()[0].row, 1);

          if (this.props.teams.find(t => t.name === selected) && parent !== this.props.company.name) {
            let team = this.props.teams.find(t => t.name === selected);

            this.props.history.push(`/companies/${this.props.company.id}/programs/${team.program_id}/teams/${team.id}`);
          }
        }
      }
    ];

    this.state = {
      chartOptions: {
        minColor: '#ee2a00',
        midColor: '#f0ff0c',
        maxColor: '#06962d',
        minColorValue: 0,
        maxColorValue: 100,
        noColor: '#b4b4b4',
        headerHeight: 50,
        showTooltips: false,
        showScale: true,
        height: 600,
        fontFamily: 'Avenir Next',
        fontSize: 18
      },
      treeData: [
        ['Name', 'Parent', 'Size', 'Score (color)'],
        [ props.company.name, null, props.programs.length, null ]
      ]
    };

    this.formatTreeData = this.formatTreeData.bind(this);
    this.getProgramSize = this.getProgramSize.bind(this);
  }

  getProgramSize(programId) {
    let num = 0;

    for (let i = 0; i < this.props.teams.length; i++) {
      if (this.props.teams[i].program_id === programId)
        num++;
    }

    return num;
  }

  getProgramName(programId) {
    let index = this.props.programs.map(x => x.id).indexOf(programId);
    return this.props.programs[index].name;
  }

  async formatTreeData() {
    const programs = this.props.programs;
    const teams = this.props.teams;

    let programScores = (await GreenLeafApi.Program.getOverallScore({ company_id: this.props.company.id })).data.scores;
    let scores = (await GreenLeafApi.TeamAssessment.getOverallScore({ company_id: this.props.company.id })).data.score;

    const data = [
      ['Name', 'Parent', 'Size', 'Score (color)'],
      [ this.props.company.name, null, this.props.programs.length, 0 ]
    ];

    for (let i = 0; i < programs.length; i++) {
      let score = programScores.find(s => s.program_id === programs[i].id);
      data.push([programs[i].name, this.props.company.name, this.getProgramSize(programs[i].id), score ? score['program_score'] : null]);
    }

    for (let i = 0; i < teams.length; i++) {
      let score = scores.find(a => a['team_id'] === teams[i].id);
      data.push([teams[i].name, this.getProgramName(teams[i].program_id), teams[i].size, score ? score['score'] : null]);
    }

    this.setState({ treeData: data });
  }

  async componentWillMount() {
    if (this.props.teams.length > 0 && this.props.programs.length > 0) {
      try {
        await this.formatTreeData();
      } catch (e) {
        this.props.onError(e);
      }
    }
  }

  render() {
    const tooltip = ( <Tooltip id="tooltip"> Left click to zoom in, right click to zoom out. </Tooltip> );

    return (
      <div className={'company-map-container panel'}>
        <Chart
          chartType="TreeMap"
          data={this.state.treeData}
          options={this.state.chartOptions}
          chartEvents={this.chartEvents}
          width="100%"
          height="100%"/>
        <OverlayTrigger placement="bottom" overlay={tooltip}>
          <i className="fas fa-question-circle"/>
        </OverlayTrigger>
      </div>
    );
  }
}

CompanyTreeMapByProgram.propTypes = {
  company: PropTypes.object,
  programs: PropTypes.array,
  teams: PropTypes.array,
  onError: PropTypes.func.isRequired,
};

export default withRouter(CompanyTreeMapByProgram);


// WEBPACK FOOTER //
// ./src/components/company/CompanyTreeMapByProgram.js